var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"List"}},[_c('div',{staticClass:"wrapper"},[_c('brand-list',{staticClass:"boxwrap",attrs:{"title":_vm.listTitle,"subtext":_vm.subtext,"list":_vm.popularList,"isShowBtn":false,"type":_vm.$route.params.category}}),_c('sort-list',{staticClass:"boxwrap",attrs:{"title":_vm.sortListTitle,"list":_vm.list,"isShowBtn":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }